export const getCentraMedia = (
  media: Record<string, string[]> | undefined,
  key: string,
) => {
  if (!media) return undefined;

  let href = media[key]?.[0] as string | { href: string; alt?: string };

  if (href && typeof href === "object") {
    href = href.href;
  }

  return {
    href,
    alt: "",
  };
};
